import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';
import { Client } from '@appbolaget/aware-model';
import { InitialsPipe, SecureImagePipe } from '@helpers/pipes';

@Component({
    selector: 'app-client-avatar',
    templateUrl: 'client-avatar.component.html',
    imports: [InitialsPipe, NgTemplateOutlet, NgClass, SecureImagePipe]
})
export class ClientAvatarComponent {
    readonly client = input<Client>(undefined);
    readonly clients = input<Client[]>(undefined);
    readonly dark = input<boolean>(undefined);
    readonly group = input<boolean>(undefined);

    get clientsComputed(): Client[] {
        const client = this.client();
        return client ? [client] : this.clients();
    }

    get clientsSpliced(): Client[] {
        return this.clientsComputed.slice(0, 4);
    }

    get showAsGroup(): boolean {
        return this.clientsComputed.length > 1 || this.group();
    }
}
